import "./App.scss";
import React from "react";
import { Switch, Route, useLocation } from "react-router-dom";
import SignIn from "./SignIn/SignIn";
import SignOut from "./SignIn/SignOut";

function App() {
  const location = useLocation();

  return (
    <div className="App">
      <Switch location={location} key={location.key}>
        <Route exact path="/signout" component={SignOut} />
        <Route exact path="/:keyid" component={SignIn} />

        <Route path="*">
          <SignIn />
        </Route>
      </Switch>
    </div>
  );
}

export default App;
